import * as React from 'react';
import { UNLEASH_FEATURE_NAMES } from '../../shared/unleash/feature-names';
import { getThresholdProximityFromExperiment } from '../config';
import { useShowTag } from '../hooks/ad';
import { useMemo } from 'react';

export type Props = {
    id: string;
    targetId: string;
    pageType?: string;
    className?: string;
    deviceType?: string;
    vertical?: string;
    proximity?: number;
    threshold?: number;
};

function useGetProximityAndThresholdFromExperiments(
    defaultProximity: number = 0,
    defaultThreshold: number = 0,
) {
    const { proximity, threshold } = useMemo(() => {
        const srE = getThresholdProximityFromExperiment(
            UNLEASH_FEATURE_NAMES.enableSearchFirstResultHalfProx,
        );
        // object page experiment
        const opE = getThresholdProximityFromExperiment(
            UNLEASH_FEATURE_NAMES.objectPageInScreenExperiment,
        );
        if (srE || opE) {
            const proximity = srE?.proximity || opE?.proximity;
            const threshold = srE?.threshold || opE?.threshold;
            return {
                proximity: proximity || defaultProximity,
                threshold: threshold || defaultThreshold,
            };
        } else
            return { proximity: defaultProximity, threshold: defaultThreshold };
    }, [defaultProximity, defaultThreshold]);
    // search result experiment

    return { proximity, threshold };
}

export function Banner(props: Props) {
    const {
        id,
        targetId,
        pageType,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        proximity = 100,
        threshold = 0.0,
    } = props;
    const { proximity: _proximity, threshold: _threshold } =
        useGetProximityAndThresholdFromExperiments(proximity, threshold);

    useShowTag(targetId, _proximity, _threshold);

    if (pageType && pageType === 'object') {
        // Rendered from objectpages-podium already
        return null;
    }
    return (
        <div id={`${targetId}-container`} className={className}>
            <div
                id={targetId}
                className={`inline-container ${id}-inline-container`}
            >
                <span className="ad-info-wrap">
                    <div id={`${targetId}-button`} className="ad-info" />
                </span>
            </div>
        </div>
    );
}
